import { useState, useEffect } from 'react';
import Button from '../../../../components/Button/Button';
import Modal from '../../../../components/Modal/Modal';
import QRCode from 'qrcode';
import alert from '../../../../helpers/alert';

const ShinhanQRCode = ({ qrString, update }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [qrDataUrl, setQrDataUrl] = useState('');

  useEffect(() => {
    if (isOpen && qrString) {
      const normalizedQr = qrString.startsWith('mobileSign:')
        ? qrString
        : `mobileSign:${qrString}`;

      QRCode.toDataURL(normalizedQr, { width: 500, margin: 1 }, (err, url) => {
        if (!err) setQrDataUrl(url);
      });
    }
  }, [isOpen, qrString]);

  const showQrModal = async () => {
    await update();

    if (qrString) {
      setIsOpen(true);
    } else {
      alert.error('QR Ð¾ÑÑÑÑÑÑÐ²ÑÐµÑ');
    }
  };

  return (
    <>
      <Button fill onClick={showQrModal}>
        ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ QR Ð´Ð»Ñ eGov Mobile (SHINHAN)
      </Button>
      <Modal
        contentStyle={{
          height: 'fit-content',
        }}
        width={500}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        title="QR Ð´Ð»Ñ eGov Mobile (SHINHAN)"
      >
        <div style={{ textAlign: 'center', padding: 20 }}>
          {qrDataUrl && (
            <img
              style={{
                width: '100%',
                aspectRatio: 1,
              }}
              src={qrDataUrl}
              alt="QR Code"
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default ShinhanQRCode;
